var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIconMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1784 1.65863L14.0958 3C13.8551 2.1377 13.3495 1.37915 12.6549 0.838214C11.9604 0.29728 11.1143 0.00315699 10.2438 0H4.0104C2.94765 0.00293803 1.92925 0.439382 1.17777 1.21394C0.426289 1.9885 0.00285048 3.03819 0 4.13358L0 7.86642C0.00285048 8.96181 0.426289 10.0115 1.17777 10.7861C1.92925 11.5606 2.94765 11.9971 4.0104 12H10.2438C11.1141 11.997 11.96 11.7031 12.6545 11.1625C13.349 10.622 13.8548 9.86381 14.0958 9.00186L16.1784 10.3414C17.181 10.987 18 10.5269 18 9.30056V2.69944C18 1.48052 17.181 1.01299 16.1784 1.65863Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconMd);
export default __webpack_public_path__ + "static/media/videoIconMd.286e5dba22a6ba1a617ea5208c7085e8.svg";
export { ForwardRef as ReactComponent };